<template>
  <div>
    <v-row>
      <v-col cols="1">
        <text-field-like
            label="追番"
            :value="dataPropertyImplementationView.index"
            hide-details>
        </text-field-like>
      </v-col>
      <v-col cols="7">
        <text-field-like
            label="名称"
            :value="dataPropertyImplementationView.name"
            :value-id="dataPropertyImplementationView.id"
            hide-details>
        </text-field-like>
      </v-col>
      <v-col cols="2">
        <text-field-like
            label="データ型"
            :value="dataPropertyImplementationView.dataType"
            hide-details>
        </text-field-like>
      </v-col>
      <v-col cols="1">
        <text-field-like
            label="主キー"
            hide-details>
          <readonly-checkbox :value="dataPropertyImplementationView.isPrimaryKey"></readonly-checkbox>
        </text-field-like>
      </v-col>
      <v-col cols="1">
        <text-field-like
            label="必須"
            hide-details>
          <readonly-checkbox :value="dataPropertyImplementationView.isRequired"></readonly-checkbox>
        </text-field-like>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <text-field-like
            label="説明"
            :value="dataPropertyImplementationView.description"
            placeholder="未設定"
            multi-line
            hide-details>
        </text-field-like>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <local-id-field
            v-if="readonly"
            label="内部ID"
            :value="dataPropertyImplementationView.localId"
            hide-details>
        </local-id-field>
        <v-text-field
            v-else
            label="内部ID"
            v-model="dataPropertyImplementationView.localId"
            :rules="[v => !!v || '内部IDが必要です']"
            @change="handleChange"
            autofocus>
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {cloneDeep} from "lodash";
import LocalIdField from "@/components/molecules/LocalIdField.vue";
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";
export default {
  name: "DataPropertyImplementationForm",
  components: {ReadonlyCheckbox, LocalIdField, TextFieldLike},
  model: {
    prop: 'dataPropertyImplementation',
    event: 'change'
  },
  props: {
    dataPropertyImplementation: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataPropertyImplementationView: {}
    };
  },
  methods: {
    handleChange() {
      this.$emit('change', cloneDeep(this.dataPropertyImplementationView));
    },
  },
  watch: {
    dataPropertyImplementation: {
      immediate: true,
      handler(dataPropertyImplementation) {
        this.dataPropertyImplementationView = cloneDeep(dataPropertyImplementation) ?? {};
      }
    }
  }
}
</script>

<style scoped>

</style>
